import React from 'react'
import { ChevronRight } from 'lucide-react'
import { BuildingOffice2Icon } from '@heroicons/react/24/outline'
import type { HubProject } from '../../../api/data360'
import ProjectHubActionLinks from './ProjectHubActionLinks'
import {
  MetaChip,
  PROJECT_HUB_META_CLASS,
  PROJECT_HUB_NAME_CLASS,
  getHubProjectDisplayFields,
  handleRowKeyDown
} from './projectHubShared'

export default function ProjectHubCard({
  project,
  onOpen
}: {
  project: HubProject
  onOpen: (project: HubProject) => void
}) {
  const { client, metaLine, pipeSets } = getHubProjectDisplayFields(project)
  const actionProjectId = project.wpsShadowId || project.id

  const handleCardClick = () => {
    onOpen(project)
  }
  const handleCardKey = (e: React.KeyboardEvent<HTMLDivElement>) => {
    handleRowKeyDown(e, handleCardClick)
  }

  return (
    <div
      data-testid={`project-hub-card-${actionProjectId || project.data360ProjectId}`}
      role="button"
      tabIndex={0}
      aria-label={`Open ${project.name}`}
      onClick={handleCardClick}
      onKeyDown={handleCardKey}
      className="relative cursor-pointer overflow-hidden rounded-xl border border-[#E2E5EA] bg-white shadow-[0_1px_3px_rgba(0,0,0,0.04)] transition-all duration-200 hover:-translate-y-[2px] hover:shadow-[0_8px_24px_rgba(0,39,63,0.08)] focus:outline-none focus:ring-2 focus:ring-blueprint-blue/40"
    >
      <div className="absolute left-0 right-0 top-0 h-[3px] bg-hero-red" />

      <div className="p-5 pt-6">
        <div className="mb-2 flex items-start justify-between gap-3">
          <div className="min-w-0 flex-1">
            <h3 className={PROJECT_HUB_NAME_CLASS}>
              {project.name}
            </h3>
            <p className={`mt-0.5 flex items-center gap-1.5 ${PROJECT_HUB_META_CLASS}`}>
              <BuildingOffice2Icon className="h-3 w-3 flex-shrink-0" />
              <span className="truncate">{client}</span>
            </p>
          </div>
          <ChevronRight className="mt-1 h-4 w-4 flex-shrink-0 text-heritage-grey" />
        </div>

        <p className={`mt-1 ${PROJECT_HUB_META_CLASS}`}>{metaLine}</p>

        <div className="mt-3 flex flex-wrap items-center gap-1.5">
          <MetaChip>{pipeSets}</MetaChip>
        </div>

        {actionProjectId ? (
          <div className="mt-4 border-t border-[#EEF0F3] pt-3">
            <ProjectHubActionLinks projectId={actionProjectId} size="md" />
          </div>
        ) : null}
      </div>
    </div>
  )
}
